import { HttpInterceptorFn, HttpErrorResponse } from '@angular/common/http';
import { inject } from '@angular/core';
import { catchError, throwError } from 'rxjs';
import { VersionService } from '../services/version.service';
import { environment } from '../../environments/environment';

export const versionInterceptor: HttpInterceptorFn = (req, next) => {
  const versionService = inject(VersionService);

  // Solo agregar header de versión a requests de nuestra API
  if (req.url.startsWith(environment.apiUrl)) {
    const appVersion = versionService.getAppVersion();
    
    req = req.clone({
      setHeaders: {
        'X-App-Version': appVersion
      }
    });
  }

  return next(req).pipe(
    catchError((error: HttpErrorResponse) => {
      // Si recibimos error 426 (Upgrade Required), mostrar modal
      if (error.status === 426) {
        versionService.showUpdateModal(error.error);
      }
      return throwError(() => error);
    })
  );
};

